import * as React from 'react';
/**
 *
 * Original name: sort alpha
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1064
 *
 */
export const SortAlphaLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m7.382 5.5-4.179 13h1.576l1.285-4h4.871l1.286 4h1.575l-4.178-13H7.382ZM6.547 13 8.5 6.923 10.453 13H6.547ZM19.5 12v.883A1.94 1.94 0 0 0 17.75 12c-2.035 0-3.25 1.215-3.25 3.25s1.215 3.25 3.25 3.25a1.886 1.886 0 0 0 1.75-1.084V18.5H21V12h-1.5Zm-1.75 5c-1.21 0-1.75-.54-1.75-1.75s.54-1.75 1.75-1.75 1.75.54 1.75 1.75S18.96 17 17.75 17Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
